import Component from '@glimmer/component';
import { action } from '@ember/object';
import { modifier } from 'ember-modifier';

interface AditoolsToolbarSignature {
  Element: HTMLDivElement;
  Args: {
    title: string;
    dropActions: boolean;
    dropTabs: boolean;
    separateTabs: boolean;
    useTitle: boolean;
  };
  Blocks: {
    context: [];
    tabs: [];
    actions: [];
  };
}

const hidePopoverOnClickOutside = modifier(function (element) {
  const globalClickListener = function (event: Event) {
    const container = element as HTMLElement;
    if (!(event.target instanceof Node) || !container.contains(event.target as HTMLElement)) {
      container.hidePopover();
    }
  };
  const body = document.querySelector('body');
  body?.addEventListener('click', globalClickListener);
  return () => {
    body?.removeEventListener('click', globalClickListener);
  };
});

export default class AditoolsToolbar extends Component<AditoolsToolbarSignature> {
  hideOnClickOutside = hidePopoverOnClickOutside;
  @action hideDropdown(event: FocusEvent) {
    const container = event.currentTarget as HTMLElement;
    const currentFocus = event.target as HTMLElement;
    // First make sure we're not in a dialog nested in a popover (or we'll create a dead UI)
    if (!(currentFocus.closest('dialog') && currentFocus.closest('dialog')?.closest('[popover]'))) {
      // Then make sure the new target isn't in the same popover
      if (!event.relatedTarget || !container.contains(event.relatedTarget as HTMLElement)) {
        container.hidePopover();
      }
    }
  }
}
